import {NgModule} from '@angular/core';
import {CbjCardTabsComponent} from './card-tabs/cbj-card-tabs.component';
import {CbjCardTabComponent} from './card-tabs/cbj-card-tab.component';
import {CommonModule} from '@angular/common';
import {CbjRippleModule} from '../ripple/index';
export class CbjNavsModule {
  
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    CbjRippleModule,
  ],
  declarations: [
    CbjCardTabsComponent,
    CbjCardTabComponent,
  ],
  exports: [
    CbjCardTabsComponent,
    CbjCardTabComponent,
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjNavsModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjNavsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjNavsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
